<template>
  <div ref="whole_page">
    <vx-card class="w-full">
      <div>
        <vs-tabs v-model="activeTab">
          <vs-tab label="Assessment">
            <div class="tab-text">
            </div>
          </vs-tab>
          <vs-tab label="Overview">
            
          </vs-tab>
        </vs-tabs>
        <div v-if="activeTab == 1"  class="vx-row w-full">
          <div class="vx-col xs:w-full sm:w-full md:w-1/2 lg:w-1/3 xl:w-1/3 w-full">
            <label v-if="companyList.length != 0">Company</label>
            <v-select  v-if="companyList.length != 0" ref="companyDropdown" class="w-full mb-2" placeholder="Search / Select Company" :options="companyList" v-model="chartCompanyDropdown" @input="clearChartData" @search:focus="clearChartData"></v-select>
            
            <label>Module</label>
            <v-select ref="ModuleDropDown" class="w-full mb-2" placeholder="Search / Select Module" :options="moduleList" v-model="chartmoduleDropdown" @input="clearChartData" @search:focus="clearChartData"></v-select>
          </div>
        </div>
        <div v-if="activeTab == 1">
          <div v-show="activeTab == 1 && chartsVisable" class="side-margin mt-4">
            <div class="vx-row w-full mt-2">
              <div class="vx-col w-full">
                <vx-card class="w-full mb-3" >
                  <Loading style="height:250px" v-if="!barchartVisable"></Loading>
                  <chartjs-bar-chart  v-if="barchartVisable"  :options="barChartOptions" :data="barChartData" ></chartjs-bar-chart>
                </vx-card>
              </div>
            </div>
            <div class="vx-row w-full mt-3 " style="min-height: 450px;">
              <div class="vx-col mb-3 sm:w-full md:w-full lg:w-1/2 xl:w-1/2 w-full">
                <vx-card  class="mb-2 h-full" code-toggler>
                  <Loading style="height:250px" v-if="!polarchartVisable" ></Loading>
                  <chartjs-polar-area-chart  v-if="polarchartVisable" :data="polarChartdata" :options="polarChartoptions" ></chartjs-polar-area-chart>
                  <template slot="codeContainer">
 Assessed: Competent (Assessed, Moderated, Evaluated) Status and UP
 Busy: Started with Module (started)
 ReadyToAssess: All formative tasks, All Sumative Tasks Submitted
 NotYetStarted: Assigned students (assigned status)
 NotYetCompetent: Not yet competent status for this module
                  </template>
                </vx-card>
              </div>
              <div class="vx-col mb-3 sm:w-full md:w-full lg:w-1/2 xl:w-1/2 w-full ">
                <vx-card :title="`Total: ${piechartTotal ? piechartTotal : 'Loading...' }`" class="mb-2 h-full" >
                  <Loading style="height:250px" v-if="!piechartVisable" ></Loading>
                  <chartjs-doughnut-chart @DoughnutChartClicked="graphClickEvent" v-if="piechartVisable" :data="pieChartdata" :options="pieChartoptions" ></chartjs-doughnut-chart>
                </vx-card>
              </div>
            </div>
            <div class="vx-row w-full mt-6">
              <div class="vx-col w-full">
                <vx-card  id="selectedStatusTable" v-show="selectedStatusTableData.length" :title="`Students With Status: ${selectedStatus}`">
                  <vs-table ref="selectedStatusTable" stripe class="vs-con-loading__container" single pagination :max-items="tasksPerPage" search :data="selectedStatusTableData">
                    <div slot="header" class="vx-row flex flex-wrap-reverse items-center flex-grow">
                  
                      <!-- ITEMS PER PAGE -->
                      <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 vx-col s:w-1/3 xs:w-full sm:w-full md:w-1/3 lg:w-1/4 xl:w-1/6">
                        <div class="p-4 border border-solid border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium" >
                          <span class="mr-2">{{ currentTaskPage * tasksPerPage - (tasksPerPage - 1) }} - {{ selectedStatusTableData.length - currentTaskPage * tasksPerPage > 0 ? currentTaskPage * tasksPerPage : selectedStatusTableData.length }} of {{ selectedStatusTableData.length }}</span>
                          <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/> 
                        </div>
                      <vs-dropdown-menu>
                        <vs-dropdown-item @click="tasksPerPage=10">
                          <span>10</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="tasksPerPage=15">
                          <span>15</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="tasksPerPage=20">
                          <span>20</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="tasksPerPage=25">
                          <span>25</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="tasksPerPage=50">
                          <span>50</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="tasksPerPage=100">
                          <span>100</span>
                        </vs-dropdown-item>
                      </vs-dropdown-menu>
                      </vs-dropdown>
                    </div>
                  
                    <template slot="thead">
                      <vs-th sort-key="userFullName">User Full Name</vs-th>
                      <vs-th sort-key="email">Email</vs-th>
                      <vs-th sort-key="mobile">Mobile</vs-th>
                    </template>
                    <template slot-scope="{data}">
                      <vs-tr :data="user" :key="indextr" v-for="(user, indextr) in data"> 
                  
                        <vs-td :data="data[indextr].userFullName">
                          {{ user.userFullName }}
                        </vs-td> 

                        <vs-td :data="data[indextr].email">
                          {{ user.email }}
                        </vs-td> 
                  
                        <vs-td :data="data[indextr].mobile">
                          {{ user.mobile }}
                        </vs-td> 

                      </vs-tr>
                    </template>
                  </vs-table>
                </vx-card>
              </div>
            </div>
            <div class="vx-row w-full mt-3 ">                              
              <div class="vx-col mb-3 sm:w-full md:w-full lg:w-1/2 xl:w-1/2 w-full ">                 
              <vx-card :title="`Additional Data:`" class="mb-2 h-full" >                   
                <Loading style="height:250px" v-if="logbookCountLoading" ></Loading>                   
                <div v-else>
                  <h3>{{`Amount Of Signable Logbooks: ${amountOfLogbooks}`}}</h3>
                </div>                 
                </vx-card>               
              </div>             
            </div>
          </div>
        </div>
        <div class="vx-row" v-if="activeTab == 0">
          <div class="vx-col xs:w-full sm:w-full md:w-1/3 lg:w-1/3 xl:w-1/3">
            <label>Company</label>
            <v-select ref="CompanyDropDown" class="w-full mb-2" placeholder="Search / Select Module" :options="companyList" v-model="selectedCompany" @input="clearModules" @search:focus="clearModules"></v-select>
            <label>Module</label>
            <v-select :disabled="!selectedCompany" ref="ModuleDropDown" class="w-full mb-2" placeholder="Search / Select Module" :options="moduleList" v-model="selectedModule" @input="clearStudents" @search:focus="clearStudents"></v-select>
          </div>

          <div class="self-center vx-col xs:w-full sm:w-full md:w-1/3 lg:w-1/3 xl:w-1/3">
            <label>Search Options</label>
            
            <div class="mb-2 vx-row info-next-to-checkcss">
              <vs-checkbox v-model="criteria.showAllStudents" color="success">Show All students</vs-checkbox>
              <vx-tooltip 
                text='Students with any status (Whether they have somethnig to assess or not)' 
                position="bottom"
                class="info-icon-on-module" 
                delay=".3s">
                <feather-icon
                    svgClasses="h-6 w-6"
                    class="p-2 cursor-pointer"
                    icon="InfoIcon"
                  >
                </feather-icon>
              </vx-tooltip>
            </div>
            <div class="vx-row">
              <vs-checkbox v-model="criteria.showAllStudentsThatReachedEndTask" color="success">Show Students that has reached end task</vs-checkbox>
            </div>
          </div>
          
          <div style="justify-content:center; display: flex;" class="self-center vx-row xs:w-full sm:w-full md:w-1/4 lg:w-1/4 xl:w-1/4">
            <vs-button :disabled="!selectedModule"  vs-align="center" class="shadow" color="success" @click="listModuleStudents">Search</vs-button>
          </div>
          <div v-show="showStudentTable" class="w-full" >
            <vs-divider>Students</vs-divider>
            <vs-table  ref="studentTable" stripe class="vs-con-loading__container" single @selected="getTaskProgress" pagination :max-items="criteria.pageSize" search :data="studentList" v-scroll-to="'#taskProgressCard'" > <!-- @sort="handleSort" -->

              <div slot="header" class="vx-row flex flex-wrap-reverse items-center flex-grow">
                <!-- ITEMS PER PAGE -->
                <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 vx-col xs:w-full sm:w-full md:w-1/6 lg:w-1/6 xl:w-1/6">
                  <div class="p-4 border border-solid border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium" >
                    <span class="mr-2">Page Size: {{criteria.pageSize}}</span>
                    <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
                  </div>
                    <vs-dropdown-menu>
                      <vs-dropdown-item @click="criteria.pageSize=10">
                        <span>10</span>
                      </vs-dropdown-item>
                      <vs-dropdown-item @click="criteria.pageSize=15">
                        <span>15</span>
                      </vs-dropdown-item>
                      <vs-dropdown-item @click="criteria.pageSize=20">
                        <span>20</span>
                      </vs-dropdown-item>
                      <vs-dropdown-item @click="criteria.pageSize=25">
                        <span>25</span>
                      </vs-dropdown-item>
                      <vs-dropdown-item @click="criteria.pageSize=50">
                        <span>50</span>
                      </vs-dropdown-item>
                      <vs-dropdown-item @click="criteria.pageSize=100">
                        <span>100</span>
                      </vs-dropdown-item>
                    </vs-dropdown-menu>
                </vs-dropdown>

                <div class="flex flex-wrap-reverse items-center vx-col xs:w-full sm:w-full md:w-1/6 lg:w-1/6 xl:w-1/6">
                  <div id="TaskProgressRefreshButton" class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-success border border-solid border-success" @click="listModuleStudents">
                    <feather-icon icon="RefreshCcwIcon" svgClasses="h-4 w-4" />
                    <span class="ml-2 text-base text-success">Refresh</span>
                  </div>
                </div>
              </div>
                <template slot="thead">
                  <vs-th>Name</vs-th>
                  <vs-th>ID Number</vs-th>
                  <vs-th>Mobile</vs-th>
                  <vs-th>Email</vs-th>
                  <vs-th>Queries</vs-th>
                  <vs-th>Tasks At Student</vs-th>
                  <vs-th>Status</vs-th>
                  <vs-th></vs-th>
                </template>

                <template slot-scope="{data}">
                  <vs-tr :data="student" :key="indextr" v-for="(student, indextr) in data">

                    <vs-td :data="data[indextr].studentFullName">
                      {{ student.studentFullName }}
                    </vs-td>

                    <vs-td :data="data[indextr].studentIdNumber">
                      {{ student.studentIdNumber }}
                    </vs-td>

                    <vs-td :data="data[indextr].studentMobile">
                      {{ student.studentMobile }}
                    </vs-td>

                    <vs-td :data="data[indextr].studentEmail">
                      {{ student.studentEmail }}
                    </vs-td>

                    <vs-td :data="data[indextr].statusName">
                      <vs-chip :color="getQueriesColor(student.numQueries)"><strong>{{ student.numQueries }}</strong></vs-chip>
                    </vs-td>

                    <vs-td :data="data[indextr].studentTasks">
                      <vs-chip v-if="student.studentTasks" color="success"> <strong>{{ student.studentTasks }}</strong></vs-chip>
                      <vs-chip v-else color="success"> 0 <strong></strong></vs-chip>
                    </vs-td>

                    <vs-td :data="data[indextr].lastTaskCompleted" style="text-align:center">
                      <div v-if="student.numQueries">
                        <vs-chip v-if="student.lastTaskCompleted" color="danger"> <strong>Query</strong></vs-chip>
                      </div>
                      <div v-else-if="student.moduleStatusId == 1 || student.moduleStatusId == 2 || student.moduleStatusId == 9">
                        <vs-chip v-if="student.lastTaskCompleted" color="success"> <strong>Completed</strong></vs-chip>
                        <vs-chip v-else color="danger"> Busy <strong></strong></vs-chip>
                      </div>
                      <div v-else>
                        <vs-chip v-if="student.moduleStatusId == 6"  color="success"><strong>{{student.moduleStatusName}}</strong></vs-chip>
                        <vs-chip v-else-if="student.moduleStatusId == 14" color="danger"><strong>Not Yet Competent</strong></vs-chip>
                        <vs-chip v-else-if="student.moduleStatusId != 10 && student.moduleStatusId != 5"  color="success"><strong>{{student.moduleStatusName}}</strong></vs-chip>
                        <vs-chip v-else-if="student.moduleStatusId == 10"  color="success"><strong>Competent</strong></vs-chip>
                        <vs-chip v-else-if="student.moduleStatusId == 5" color="success"><strong>All Summative Assessments Submitted</strong></vs-chip>
                      </div>
                    </vs-td>

                    <vs-td :data="data[indextr].signedAssessorFeedback">
                      <div v-if="student.signedAssessorFeedback">
                        <vs-button size="small" class="shadow" color="success">Generate Assessor Feedback</vs-button>
                      </div>
                    </vs-td>
                  </vs-tr>
                </template>
            </vs-table>
          </div>
        </div>
      </div>
    </vx-card>
    <vx-card id="taskProgressCard" class="mb-6 mt-3" :title="studentTasksCardTitle" v-show="showTaskProgress">
      <vs-table ref="taskProgressCard" stripe class="vs-con-loading__container" single @selected="handelSelectedTaskFromProgress" pagination :max-items="tasksPerPage" search :data="taskList">
        <div slot="header" class="vx-row flex flex-wrap-reverse items-center flex-grow">
          
          <!-- ITEMS PER PAGE -->
          <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 vx-col xs:w-full sm:w-full md:w-1/6 lg:w-1/6 xl:w-1/6">
            <div class="p-4 border border-solid border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium" >
              <span class="mr-2">Page Size: {{ tasksPerPage }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
            </div>
              <vs-dropdown-menu>
                <vs-dropdown-item @click="tasksPerPage=10">
                  <span>10</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="tasksPerPage=15">
                  <span>15</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="tasksPerPage=20">
                  <span>20</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="tasksPerPage=25">
                  <span>25</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="tasksPerPage=50">
                  <span>50</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="tasksPerPage=100">
                  <span>100</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <template slot="thead">
          <vs-th sort-key="task">Task</vs-th>
          <vs-th sort-key="type">Type</vs-th>
          <vs-th sort-key="dateCompleted">Date Completed</vs-th>
          <vs-th sort-key="status">Status</vs-th>
          <vs-th sort-key="count">Task Count</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="task" :key="indextr" v-for="(task, indextr) in data">

            <vs-td :data="data[indextr].task">
              {{ task.task }}
            </vs-td>

            <vs-td :data="data[indextr].taskType">
              {{ task.type }}
            </vs-td>

            <vs-td :data="data[indextr].dateCompleted">
              {{ (task.dateCompleted != '0001-01-01T00:00:00' ) ? task.dateCompleted.replace("T", " ").split('.')[0] : ""}}
            </vs-td>

            <vs-td :data="data[indextr].status">
              <vs-chip v-if="task.statusId && task.statusId != 1" :color="getStatusColor(task.statusId)"> {{ task.status}} </vs-chip>
              <vs-chip v-else-if="task.statusId == 1" :color="getStatusColor(task.statusId)"> {{ 'Waiting to be Assessed' }} </vs-chip>
              <vs-chip v-else> {{ task.status}} </vs-chip>
            </vs-td>

            <vs-td :data="data[indextr].count">
              {{ task.count}}
            </vs-td>

          </vs-tr>
        </template>
      </vs-table>
      
    </vx-card>

    <vx-card id="studentTaskTable" class="mb-6 mt-3" :title="studentTasksCardTitle" v-show="isStudentTasksListHidden">
      <div class="mb-3" v-if="(taskType == 9 || taskType == 3) && !isSurvey">
        <h6><strong>{{`Passing Percentage: ${passPercentage}%`}}</strong></h6>
      </div>
      <vs-table ref="studentTaskTable" stripe class="vs-con-loading__container" single @selected="handleSelectedTask" pagination :max-items="tasksPerPage" search :data="selectedTaskList">
        <div slot="header" class="vx-row flex flex-wrap-reverse items-center flex-grow">
          
          <!-- ITEMS PER PAGE -->
          <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 vx-col xs:w-full sm:w-full md:w-1/6 lg:w-1/6 xl:w-1/6">
            <div class="p-4 border border-solid border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium" >
              <span class="mr-2">Page Size: {{ tasksPerPage }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
            </div>
              <vs-dropdown-menu>
                <vs-dropdown-item @click="tasksPerPage=10">
                  <span>10</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="tasksPerPage=15">
                  <span>15</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="tasksPerPage=20">
                  <span>20</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="tasksPerPage=25">
                  <span>25</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="tasksPerPage=50">
                  <span>50</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="tasksPerPage=100">
                  <span>100</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
          </vs-dropdown>

          <!-- <div class="self-center vx-col xs:w-full sm:w-full md:w-1/3 lg:w-1/3 xl:w-1/3">
            <label>Search Options</label>
            <div class="mb-4">
            </div>
          </div> -->
        </div>


        <template slot="thead">
          <vs-th sort-key="taskDisplayId">Task Name</vs-th>
          <vs-th sort-key="taskType">Type</vs-th>
          <vs-th sort-key="completedDate">Date Completed</vs-th>
          <vs-th v-if="(taskType == 9 || taskType == 3) && !isSurvey" sort-key="achievedMarks">Percent Achieved</vs-th>
          <vs-th sort-key="statusName">Status</vs-th>
          <vs-th sort-key="assessorName">Assessor</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="task" :key="indextr" v-for="(task, indextr) in data">

            <vs-td :data="data[indextr].taskDisplayId">
              {{ task.taskDisplayId + " : " + task.taskName }}
            </vs-td>

            <vs-td :data="data[indextr].taskType">
              {{ task.taskType }}
            </vs-td>

            <vs-td :data="data[indextr].completedDate">
              {{ (task.completedDate != null && task.completedDate != undefined) ? task.completedDate.replace("T", " ").split('.')[0] : ""}}
            </vs-td>

            <vs-td v-if="(taskType == 9 || taskType == 3) && !isSurvey" :data="data[indextr].achievedMarks">
              <vs-chip v-if="task.totalMarks" :color="task.totalMarks >= task.passPercentage ?'success':'danger'">{{`${(task.totalMarks)}%`}}</vs-chip>
              <vs-chip v-else color="warning">No Marks Recorded</vs-chip>
            </vs-td>           

            <vs-td :data="data[indextr].statusName">
              <vs-chip v-if="task.statusId && task.statusId != 1" :color="getStatusColor(task.statusId)">{{ task.statusDisplayName}}</vs-chip>
              <vs-chip v-else-if="task.statusId == 1" :color="getStatusColor(task.statusId)"> {{ 'Waiting to be Assessed' }} </vs-chip>
              <vs-chip v-else color="danger">Not Completed</vs-chip>
            </vs-td>

            <vs-td v-if="data[indextr].remedialTimer || data[indextr].remedialTimer == 0" :style="task.remedialTimer > 7 ? 'color:red' : ''" :data="data[indextr].remedialTimer">
              {{7-task.remedialTimer}} {{7-task.remedialTimer != 1 ? 'Days Left' : 'Day Left' }}
            </vs-td>

            <vs-td :data="data[indextr].assessorName">
              {{ task.assessorName}}
            </vs-td>

          </vs-tr>

        </template>
      </vs-table>
      <vs-divider class="mb-6 pt-0"></vs-divider>
      <div class="vx-row">
        <vs-spacer></vs-spacer>
        <div class="vx-col">
          <vs-button color="warning" type="border" class="mb-2" v-scroll-to="'#studentInfoCard'" @click="cancelTaskView">Close</vs-button>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import ChartjsPolarAreaChart from "../../components/chart/ChartjsPolarAreaChart.vue"
  import ChartjsDoughnutChart from "../../components/chart/ChartjsDoughnutChart.vue"
  import ChartjsBarChart from "../../components/chart/ChartjsBarChart.vue"
  import Loading from "../../components/Loading.vue"
export default {
  data(){
    return{
      companyList:[],
      selectedCompany:null,
      moduleList:[],
      selectedModule:null,
      studentList:[],
      selectedStudent:null,
      taskList:[],
      selectedTask:null,
      selectedTaskList:[],
      showStudentTable:false,
      criteria: {
        pageSize: 10,
        pageNumber: 0,
        sortKey: "",
        sortOrder: "",
        searchPhrase: "",
        showInactive: false,
        showAllStudents: false,
        showAllStudentsThatReachedEndTask:false
      },
      tasksPerPage:10,
      showTaskProgress:false,
      studentTasksCardTitle:"",
      isStudentTasksListHidden:false,
      taskType:0,
      activeTab:0,
      chartmoduleDropdown:null,
      barchartVisable:false,
      piechartVisable:false,
      polarchartVisable:false,
      barChartData:{
        labels: [],
        datasets: [{
          label: "",
          backgroundColor: [],
          data: []
        }]
      },
      barChartOptions:{
        legend: { 
          display: false,
          labels: {
            usePointStyle: true,
            boxWidth: 20
          },
        },
        title: {
          display: true,
          text: 'Assessed Students this past week'
        },
        responsive: true,
        maintainAspectRatio: false
      },
      pieChartdata: {
        labels: [],
        datasets: []
      },
      pieChartoptions: {
        title: {
          display: true,
          text: ['Amount of Students within a Status','(Click to view)']
        },
        legend:{
          position:'right',
          labels: {
            usePointStyle: true,
            boxWidth: 20
          },
        },
        responsive: true,
        maintainAspectRatio: false
      },
      piechartTotal:0,
      polarChartdata:{
        labels: [],
        datasets: [{
          label: "",
          backgroundColor: [],
          data: []
        }]
      },
      polarChartoptions:{
        legend: { 
          position:'right',
          labels: {
            usePointStyle: true,
            boxWidth: 20
          },
        },
        scale: {
          display: false
        },
        title: {
          display: true,
          text: 'Status Overview'
        },
        responsive: true,
        maintainAspectRatio: false
      },
      selectedStatus:"",
      selectedStatusTableData:[],
      chartCompanyDropdown:null,
      chartsVisable:false,
      logbookCountLoading:true,
      amountOfLogbooks:0,
    }
  },
  components:{
    'v-select': vSelect,
    ChartjsPolarAreaChart,
    ChartjsDoughnutChart,
    ChartjsBarChart,
    Loading
  },
  watch:{
    chartCompanyDropdown:function(){
      if(this.chartCompanyDropdown){
        this.chartmoduleDropdown = null;
        this.getModules(this.chartCompanyDropdown.value);
      }
    },
    chartmoduleDropdown: function(){
      if(this.chartmoduleDropdown){
        this.chartsVisable = true;
        this.getLogbookCount();
      }
      else{
        this.chartsVisable = false;
      }
      if(!this.barChartData.datasets.length){
        this.getbarChartData();
      }
      if(!this.pieChartdata.datasets.length){
        this.getPieChartData();
      }
      if(!this.polarChartdata.datasets.length){
        this.getpolarChartdata();
      }
    },
    selectedCompany: function(){
      if(this.selectedCompany){
        this.getModules(this.selectedCompany.value);
      }
    }
  },
  computed:{
    currentTaskPage() {
      if (this.isMounted) {
        return this.$refs.studentTable.currentx;
      }
      return 0;
    },
    currentTaskProgress() {
      if (this.isMounted) {
        return this.$refs.studentTable.currentx;
      }
      return 0;
    },
  },
  methods:{
    initVal(){
      this.selectedCompany = null;
      this.companyList = [];
      this.moduleList = [];
      this.selectedModule = null;
      this.studentList = [];
      this.selectedStudent = null;
      this.taskList = [];
      this.selectedTask = null;
      this.selectedTaskList = [];
      this.showStudentTable = false;
      this.showTaskProgress = false;
      this.isStudentTasksListHidden = false;
      this.taskType = 0
    },
    clearStudents(){
      this.showStudentTable = false;
      this.studentList = [];
      this.selectedStudent = null;
      this.taskList = [];
      this.selectedTask = null;
      this.selectedTaskList = [];
      this.showTaskProgress = false;
      this.isStudentTasksListHidden = false;
    },
    clearSelectedStudent(){
      this.selectedStudent = null;
      this.taskList = [];
      this.selectedTask = null;
      this.selectedTaskList = [];
      this.showTaskProgress = false;
      this.isStudentTasksListHidden = false;
    },
    showLoadingOnElement(element, scale, type) {
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    },
    getCompanies(){
      var self = this;
      self.showLoadingOnElement("CompanyDropDown",0.45,"corners");
      var onSuccess = response =>{
        self.companyList = response.data.map((item) => {return {label: item.text, value: item.value} });
      }
    
      var onFinally = response =>{
        if(self.$refs.CompanyDropDown){
          self.$vs.loading.close(self.$refs.CompanyDropDown.$el);
        }
      }
    
      self.$ajaxGet(self, `monitor/siteCompany` , onSuccess, onFinally);
    },
    getModules(companyId){
      var self = this;
      self.showLoadingOnElement("ModuleDropDown",0.45,"corners");
      var onSuccess = response =>{
        self.moduleList = response.data.map((item) => {return {label: item.text, value: item.value} });
      }
    
      var onFinally = response =>{
        if(self.$refs.ModuleDropDown){
          self.$vs.loading.close(self.$refs.ModuleDropDown.$el);
        }
      }
    
      self.$ajaxGet(self, `monitor/siteModules?companyId=${companyId}` , onSuccess, onFinally);
    },
    listModuleStudents(){
      var self = this;
      self.showLoadingOnElement("whole_page",1,"corners");

      var onSuccess = response =>{
        self.showStudentTable = true;
        self.studentList = response.data.records;
      }
    
      var onFinally = response =>{
        if(self.$refs.whole_page){
          self.$vs.loading.close(self.$refs.whole_page.$el);
        }
      }

      self.$ajaxPost(self, `monitor/studentList/${this.selectedModule.value}/${this.selectedCompany.value}` ,this.criteria, onSuccess, onFinally);
    },
    getStatusColor(statusId) {
      var self = this;
      if(statusId == 6)
        return 'primary';
      else if(statusId == 3|| statusId == 2 || statusId == 15)
        return 'success';
      else if(statusId == 5 || statusId == 10)
        return 'danger';
      else if(statusId == 0)
        return 'light'
      else if(statusId == 1){
        return 'danger'
      }
      else
        return 'warning'; 
    },
    getQueriesColor(numQueries) {
      var self = this;
      if(numQueries == 0)
        return 'success';
      else
        return 'danger';
    },
    getTaskProgress(selectedStudent){
      var self = this;
      self.showLoadingOnElement("whole_page",1,"corners");
      this.clearSelectedStudent();
      this.selectedStudent = selectedStudent;
      this.showTaskProgress = true;
      self.studentTasksCardTitle = "Tasks for " + selectedStudent.studentFullName;
      var onSuccess = response =>{
        self.taskList = response.data;
      }
    
      var onFinally = response =>{
        if(self.$refs.whole_page){
          self.$vs.loading.close(self.$refs.whole_page.$el);
        }
      }
    
      self.$ajaxGet(self, `monitor/loadTasksFor?userId=${selectedStudent.id}&moduleId=${self.selectedModule.value}` , onSuccess, onFinally);
    },
    handelSelectedTaskFromProgress(selectedTask){
      var self = this;
      self.showLoadingOnElement("whole_page",1,"corners");
      self.isStudentTasksListHidden = true;
      this.showTaskProgress = false;
      var onSuccess = response =>{
        self.selectedTaskList = response.data;
      }
    
      var onFinally = response =>{
        if(self.$refs.whole_page){
          self.$vs.loading.close(self.$refs.whole_page.$el);
        }
      }
    
      self.$ajaxGet(self, `monitor/TaskListForTask?userId=${this.selectedStudent.id}&moduleId=${this.selectedModule.value}&taskId=${selectedTask.taskId} ` , onSuccess, onFinally);
    },
    handleSelectedTask(selectedTask){
      let routeData = this.$router.resolve({ path: '/monitor/ViewTask', query: { TaskLogId: selectedTask.logId} });
      window.open(routeData.href, '_blank');
    },
    cancelTaskView(){
      this.isStudentTasksListHidden = false;
      this.showTaskProgress = true;
    },
    clearModules(){
      this.clearStudents();
      this.moduleList = [];
      this.selectedModule = false;
    },
    getbarChartData(){
      var self = this;

      var onSuccess = response =>{
        this.barChartData = response.data;
        this.barchartVisable = true;
      }
      if(self.chartCompanyDropdown){
        self.$ajaxGet(self, `Monitor/BarChartData?moduleId=${this.chartmoduleDropdown.value}&companyId=${self.chartCompanyDropdown.value}` , onSuccess);
      }
      else{
        self.$ajaxGet(self, `Monitor/BarChartData?moduleId=${this.chartmoduleDropdown.value}` , onSuccess);
      }
    },
    getPieChartData(){
      var self = this;
      var onSuccess = response =>{
        this.pieChartdata = response.data;
        this.piechartVisable = true;
        for (let i = 0; i < response.data.datasets[0].data.length; i++) {
          this.piechartTotal += response.data.datasets[0].data[i];
        }
      }
      if(self.chartCompanyDropdown){
        self.$ajaxGet(self, `Monitor/PieChartData?moduleId=${this.chartmoduleDropdown.value}&companyId=${self.chartCompanyDropdown.value}` , onSuccess);
      }
      else{
        self.$ajaxGet(self, `Monitor/PieChartData?moduleId=${this.chartmoduleDropdown.value}` , onSuccess);
      }
    },
    getpolarChartdata(){
      var self = this;
      var onSuccess = response =>{
        this.polarChartdata = response.data;
        this.polarchartVisable = true;
      }
      if(self.chartCompanyDropdown){
        self.$ajaxGet(self, `Monitor/PolarChartData?moduleId=${this.chartmoduleDropdown.value}&companyId=${self.chartCompanyDropdown.value}` , onSuccess);
      }
      else{
        self.$ajaxGet(self, `Monitor/PolarChartData?moduleId=${this.chartmoduleDropdown.value}` , onSuccess);
      }
    },
    clearChartData(){
      this.piechartVisable = false;
      this.barchartVisable = false;
      this.polarchartVisable = false;
      this.piechartTotal = 0;
      this.pieChartdata.datasets = [];
      this.pieChartdata.labels = [];
      this.barChartData.datasets = [];
      this.barChartData.labels = [];
      this.polarChartdata.datasets = [];
      this.polarChartdata.labels = [];
      this.selectedStatusTableData = [];
      this.chartsVisable=false;
    },
    graphClickEvent(event,item){
      if(item.length && event.target.id =="doughnut-chart"){
        var index = item[0]._index;
        this.selectedStatus = this.pieChartdata.labels[index]
        this.getStudentsByStudentModuleStatus(this.selectedStatus);
      }
    },
    getStudentsByStudentModuleStatus(selectedStatus){
      var self = this;
      self.showLoadingOnElement("selectedStatusTable",1,"corners");

      var onSuccess = response =>{
        self.selectedStatusTableData = response.data;
        var scrollOptions = {
          easing: "ease-in",
          offset: -500,
          force: true,
          cancelable: true,
          x: false,
          y: true
        };
        setTimeout(() => {
          this.$scrollTo(
            document.getElementById("selectedStatusTable"),
            300,
            scrollOptions
          );
        }, 300);
        if(self.$refs.selectedStatusTable){
          self.$vs.loading.close(self.$refs.selectedStatusTable.$el);
        }
      }

      if(self.chartCompanyDropdown){
        self.$ajaxGet(self, `Monitor/GetStudentsWith?status=${selectedStatus}&moduleId=${this.chartmoduleDropdown.value}&companyId=${self.chartCompanyDropdown.value}` , onSuccess);
      }
      else{
        self.$ajaxGet(self, `Monitor/GetStudentsWith?status=${selectedStatus}&moduleId=${this.chartmoduleDropdown.value}` , onSuccess);
      }
      
    },
    getLogbookCount(){
      var self = this;

      self.logbookCountLoading = true;

      var onSuccess = function(response) {
        self.amountOfLogbooks = response.data
        self.logbookCountLoading = false;
      };

      if(self.chartCompanyDropdown){
        self.$ajaxGet(self, `Assessor/LogbookCount?moduleId=${this.chartmoduleDropdown.value}&companyId=${self.chartCompanyDropdown.value}` , onSuccess);
      }
      else{
        self.$ajaxGet(self, `Assessor/LogbookCount?moduleId=${this.chartmoduleDropdown.value}` , onSuccess);
      }
    },
  },
  mounted(){
    this.initVal();
    this.getCompanies();
    this.isMounted = true;
  }
}
</script>

<style>

</style>